import { Box, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import * as S from './styled';

import CalendarIcon from './img/step3.svg';
import ReminderIcon from './img/step2.svg';
import LotusIcon from './img/step1.svg';
import GuidesIcon from './img/guides.svg';
import CollectionIcon from './img/collection.svg';

const GUIDES = [
    'subscription.reminderModal.accessItem2.guide1',
    'subscription.reminderModal.accessItem2.guide2',
    'subscription.reminderModal.accessItem2.guide3',
    'subscription.reminderModal.accessItem2.guide4',
    'subscription.reminderModal.accessItem2.guide5',
    'subscription.reminderModal.accessItem2.guide6',
];

const Steps = () => {
    const { t } = useTranslation();

    return (
        <Box $paddingBottom={34} dataLocator="reminderBlock">
            <S.StepItem>
                <S.ImageWrapper>
                    <LotusIcon />
                </S.ImageWrapper>
                <div>
                    <S.TitleWrapper>
                        <Text medium type="h6">
                            {t('subscription.reminderModal.step1.title')}
                        </Text>
                    </S.TitleWrapper>
                    <S.AccessItem mb={12}>
                        <S.AccessItemHeader>
                            <CollectionIcon />
                            <Text medium type="large-text">
                                {t('subscription.reminderModal.accessItem1.title')}
                            </Text>
                        </S.AccessItemHeader>
                        <Text type="small-text" color="text-secondary">
                            {t('subscription.reminderModal.accessItem1.description')}
                        </Text>
                    </S.AccessItem>
                    <S.AccessItem mb={40}>
                        <S.AccessItemHeader>
                            <GuidesIcon />
                            <Text medium type="large-text">
                                {t('subscription.reminderModal.accessItem2.title')}
                            </Text>
                        </S.AccessItemHeader>
                        <Text mb={8} type="small-text" color="text-secondary">
                            {t('subscription.reminderModal.accessItem2.description')}
                        </Text>
                        {GUIDES.map((item) => (
                            <S.GuideItem key={item} type="small-text" color="text-secondary">
                                {t(item)}
                            </S.GuideItem>
                        ))}
                    </S.AccessItem>
                </div>
            </S.StepItem>

            <S.StepItem mb={13}>
                <S.ImageWrapper>
                    <ReminderIcon />
                </S.ImageWrapper>

                <div>
                    <S.TitleWrapper>
                        <Text medium type="h6">
                            {t('subscription.reminderModal.step2.title')}
                        </Text>
                    </S.TitleWrapper>
                    <Text type="small-text" color="text-secondary" mb={27}>
                        {t('subscription.reminderModal.step2.description')}
                    </Text>
                </div>
            </S.StepItem>

            <S.StepItem>
                <S.ImageWrapper>
                    <CalendarIcon />
                </S.ImageWrapper>

                <div>
                    <S.TitleWrapper>
                        <Text medium type="h6">
                            {t('subscription.reminderModal.step3.title')}
                        </Text>
                    </S.TitleWrapper>
                    <Text type="small-text" color="text-secondary">
                        {t('subscription.reminderModal.step3.description')}
                    </Text>
                </div>
            </S.StepItem>
        </Box>
    );
};

export default Steps;
